import React from 'react';
import Button from '@material-ui/core/Button';
import InputField from 'components/pure/utils/form/InputField';
import CreateFolderDialog from './CreateFolderDialog';
import FolderList from './FolderList';
import createMatchFinder from 'utils/createMatchFinder';
import './UserFolders.styl';

export default class extends React.PureComponent {
  state = {};
  render() {
    const {searchText} = this.state;
    const findMatches = searchText && createMatchFinder(searchText);
    const folders = this.props.folders.filter(folder =>
      findMatches ? findMatches(folder.name).size > 0 : true
    );
    return (
      <div className="user-folders">
        <h4 className="header">Folders</h4>
        <InputField
          value={this.state.searchText || ''}
          placeholder="Search"
          onChange={searchText => this.setState({searchText})}
          showClearButton={true}
        />
        <FolderList
          folders={folders}
          onSelectFolder={this.props.onSelectFolder}
          filters={this.props.filters}
        />
        <Button
          variant="outlined"
          className="ev-button"
          fullWidth
          onClick={() => this.setState({showCreateFolderDialog: true})}>
          Create Folder
        </Button>
        {this.state.showCreateFolderDialog && (
          <CreateFolderDialog
            onRequestClose={() => this.setState({showCreateFolderDialog: false})}
          />
        )}
      </div>
    );
  }
}
